import { useState } from 'react';
import { storage as confStorage} from '../../config';

const SpoilerAlert = () => {
	const [isOpen, setIsOpen] = useState(localStorage.getItem(confStorage.spoiler) !== 'hide');
	const [shutUp, setShutUp] = useState(false);
	const buttonText = shutUp ? 'Ok.' : 'blablabla';

	const onClose = () => {
		if (shutUp) {
			localStorage.setItem(confStorage.spoiler, 'hide');
		} else {
			localStorage.removeItem(confStorage.spoiler);
		}
		setIsOpen(false);
	}

	if (!isOpen) {
		return <></>;
	}

	return (
		<div className="spoiler-alert">
			<div className="spoiler-alert__card">
				<img
					className="spoiler-alert__card__background"
					height="672"
					width="614"
					src="./assets/bg--spoiler-alert.png"
					alt="Spoiler Alert Background"
				/>
				<div className="spoiler-alert__card__content">
					<h2>Spoiler Alert!</h2>
					<p>Some player might find spoilers behind that curtain.</p>
					<p>If you do the Atelier Quest the first time, you might want to experience it with just the ingame tools provided and come back at a later stage of the quest. <a href="https://wiki.arcadia-online.org/Atelier_Richelle/" target="_blank" rel="noreferrer">See the wiki for further information</a></p>
					<p>Suggestions for improvements and detailed bug reports are very much appreciated.</p>
					<form>
						<p>
							<label htmlFor="idc-about-spoilers">
								<input
									id="idc-about-spoilers"
									type="checkbox"
									checked={shutUp}
									onChange={() => setShutUp(!shutUp)}
								/>
								&nbsp;Don't show again
							</label>
						</p>
						<button onClick={onClose}>
							{buttonText}
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

export default SpoilerAlert;
